import { bankid } from "@wayke-se/ecom";
export default (data, callback) => {
    const request = bankid
        .newCancelRequest()
        .withOrderRef(data.orderRef)
        .build();
    bankid
        .cancel(request)
        .then(callback)
        .catch(() => callback(false));
};
